import React, { useContext, useState } from 'react';
import { AccountHeaderContext } from 'src/lib/AccountHeaderContext';
import { AnalyticsContext } from 'src/lib/AnalyticsContext';
import { Button, cn, IconGavel, IconUser, NotificationBadge, Typography } from '@riac/design-system';
import {
  IconAlert,
  IconMessage,
  IconHand,
  IconShoppingCart,
} from '@riac/design-system';
import { useLocation } from 'react-router-dom';
import { useDebounce } from '@uidotdev/usehooks';
import { HeaderIconButton } from './HeaderIconButton';

const navigationActiveClassName = 'decoration-accent decoration-2 underline text-text hover:underline underline-offset-4';

const AlertButton = ({IconComponent, label, count, max, to, close, useAlertBadge}) => {
  const location = useLocation();
  const active = location.pathname.startsWith(to);
  return <Button to={to} unstyled onPress={close} className={cn(
    'p-2 hover:bg-neutral-200 active:bg-neutral-300 text-text-lighter hover:text-text-light active:text-text flex w-56 justify-between items-center'
  )}>
    <div className='flex items-center gap-2 font-semibold leading-6 tracking-wide text-md'>
      <div className='flex items-center justify-center w-5 h-5'>
        <IconComponent/>
      </div>
      <small className={active && navigationActiveClassName || ''}>{label}</small>
    </div>
    {count > 0 && useAlertBadge && <NotificationBadge className='' count={count} max={max}/> || ''}
    {count > 0 && !useAlertBadge && <div className='px-2 font-bold leading-5 text-center'>{count}</div> || ''}
  </Button>
}

const AlertFlyout = ({open, close}: {open: boolean, close: () => void}) => {
  const { bidsSubmitted, bidCart, messages } = useContext(AccountHeaderContext);
  return <div className={cn('overflow-hidden gap-3', open && 'flex' || 'hidden')}>
    <div className={cn(
      'shadow-black/10 shadow-lg absolute bottom-[-6px] py-3 bg-surface translate-y-full right-0 z-[100] border-thin border-neutral-200 text-left text-text',
    )}>
      <h2 className='px-3 pb-3 text-lg font-semibold leading-7 tracking-wide'>Alerts</h2>
      <hr className='pb-3'/>
      <AlertButton IconComponent={IconMessage} label='Messages' count={messages} max={20} to='/account/messages' close={close} useAlertBadge={true}/>
      <AlertButton IconComponent={IconGavel} label='My Bids' count={bidsSubmitted} max={999} to='/account/bids' close={close} useAlertBadge={false}/>
      <AlertButton IconComponent={IconShoppingCart} label='Bid Cart' count={bidCart} max={20} to='/account/cart' close={close} useAlertBadge={true}/>

    </div>
  </div>
}

export const HeaderAccountSection = () => {
  const [alertOpen, setAlertOpen] = useState(false);
  const debouncedAlertOpen = useDebounce(alertOpen, 100);
  const { bidCart, bidsSubmitted, messages } = useContext(AccountHeaderContext);
  const { sendHotjarEvent } = useContext(AnalyticsContext);

  return (
    <>
      <HeaderIconButton
        IconComponent={IconShoppingCart}
        label='Bid Cart'
        className='hidden md:block'
        notificationCount={bidCart}
        to={'/account/cart'}
        onPress={() => {
          sendHotjarEvent('navigation_bid_cart_button_clicked');
        }}
      />
      {/* <HeaderIconButton
        IconComponent={IconGavel}
        label='My Bids'
        className='hidden min-[1200px]:block'
        to='/account/bids'
      />
      <HeaderIconButton
        IconComponent={IconMessage}
        label='Messages'
        className='hidden min-[1200px]:block'
        to='/account/messages'
        notificationCount={messages}
      />
      <HeaderIconButton
        IconComponent={IconUser}
        label='Profile'
        className='hidden min-[1200px]:block'
        to='/account'
      /> */}
      <HeaderIconButton
        IconComponent={IconAlert}
        label='Alerts'
        onPress={() => {
          sendHotjarEvent('navigation_alerts_button_clicked');
          setAlertOpen(!alertOpen);
        }}
        notificationCount={(messages || 0) + (bidCart || 0)}
        hideLabel={alertOpen}
      >
        <AlertFlyout open={alertOpen} close={() => setAlertOpen(false)}/>
      </HeaderIconButton>
      {alertOpen &&
        <div className='fixed left-0 top-0 right-0 bottom-0 z-[99]' onClick={debouncedAlertOpen ? () => setAlertOpen(false) : undefined}>

        </div>
      }
    </>
  );
};
